export class UniqueNegativeNumberGenerator {
  private number = -1;

  public getUniqueID(): number {
    return this.number--;
  }
}
